// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2s_xu","label":"CategoryService_label__2uXsC","location":"CategoryService_location__3Yo8c"};